// we don't need a separate copy, below is the tested and most complete within this repo
import Picture from '../OC/oc-picture';

export default Picture;
